import { render } from "./BordersContent.vue?vue&type=template&id=610cf431"
import script from "./BordersContent.vue?vue&type=script&lang=js"
export * from "./BordersContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__